
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M3.248 12.818a2.406 2.406 0 010-1.636C3.912 9.335 6.098 5 12 5c5.902 0 8.088 4.335 8.752 6.182a2.405 2.405 0 010 1.636C20.088 14.665 17.902 19 12 19c-5.902 0-8.088-4.335-8.752-6.182zM15 12a3 3 0 11-6 0 3 3 0 016 0z","stroke":"currentColor","stroke-width":"1.8","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    